'use client'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/hooks/use-auth'
import { listKnowledgeSourcesAction } from '@/server-actions/knowledge-sources'

export const knowledgeSourcesQueryKey = ['knowledge-sources'] as const
export function useKnowledgeSourcesQuery() {
  const { user, isLoading } = useAuth()
  const tenantId = user?.impersonated_tenant_id ?? user?.tenant_id
  return useQuery({ queryKey: [...knowledgeSourcesQueryKey, user?.user_id, tenantId], enabled: !isLoading && Boolean(tenantId),
    queryFn: async () => {
      const result = await listKnowledgeSourcesAction({})
      if ('status' in result) throw new Error(result.errorMessage)
      return result
    }, refetchInterval: 15_000 })
}
